import { useEffect, useState } from "react";
import api from "../lib/api";
import { Trophy, Flame, Crown } from "lucide-react";

export default function Leaderboard() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/leaderboard?limit=30").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="container-x py-12" data-testid="leaderboard-page">
      <div className="text-xs uppercase font-bold tracking-[0.2em] text-[color:var(--brand-blue)]">Global ranking</div>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl tracking-tighter">Leaderboard</h1>
      <p className="mt-2 text-muted-foreground">Top BeforeExam learners ranked by XP earned this month.</p>

      <div className="mt-10 rounded-xl border border-border bg-card overflow-hidden">
        <div className="grid grid-cols-[60px_1fr_120px_120px] gap-3 px-5 py-3 text-[11px] font-bold uppercase tracking-wider text-muted-foreground border-b border-border">
          <div>Rank</div><div>Student</div><div className="text-right">Streak</div><div className="text-right">XP</div>
        </div>
        {items.map((u, i) => (
          <div
            key={u.id}
            className={`grid grid-cols-[60px_1fr_120px_120px] gap-3 px-5 py-4 border-b border-border last:border-0 items-center ${
              i < 3 ? "bg-yellow-400/5" : ""
            }`}
            data-testid={`leaderboard-row-${i}`}
          >
            <div className="flex items-center gap-1">
              {i === 0 && <Crown className="h-5 w-5 text-yellow-500" />}
              <span className="font-display text-lg">{i + 1}</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 rounded-full bg-[color:var(--brand-blue)] text-white flex items-center justify-center text-xs font-bold">
                {u.name?.charAt(0) || "S"}
              </div>
              <div>
                <div className="font-semibold text-sm">{u.name}</div>
                <div className="text-xs text-muted-foreground">{(u.badges || []).length} badges</div>
              </div>
            </div>
            <div className="text-right text-sm font-semibold inline-flex items-center justify-end gap-1">
              <Flame className="h-3.5 w-3.5 text-[color:var(--brand-flame)]" /> {u.streak}
            </div>
            <div className="text-right font-display text-lg inline-flex items-center justify-end gap-1">
              <Trophy className="h-4 w-4 text-yellow-500" /> {u.xp}
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="p-10 text-center text-sm text-muted-foreground">No rankings yet — start practicing to land on the leaderboard.</div>}
      </div>
    </div>
  );
}
